module.exports = __webpack_public_path__ + "static/img/proj-pic-2.bcca0cd9.png";